import { ArrowUUpLeftIcon } from '@phosphor-icons/react';

import styles from './undo-button.module.scss';

export type UndoButtonProps = {
  /** Whether the snapshot stack has anything to pop — `stack.length > 0`, the **level 0** both
   *  callers read (113600 for Field Mapping mode, 113609 for **Placement mode**). */
  canUndo: boolean;
  onUndo: () => void;
};

/**
 * The dark Undo pill (Figma `587:524140` in Field Mapping mode, `1657:789747` in **Placement
 * mode** — the two frames are identical down to the padding).
 *
 * Its own component because two unrelated surfaces render the same control over the same map
 * chrome, and a second copy of an eight-declaration pill is how two identical things start
 * drifting. It holds no state: the history lives with whoever owns the shape, so this cannot
 * disagree with the canvas about whether there is anything to undo.
 */
export function UndoButton({ canUndo, onUndo }: UndoButtonProps) {
  return (
    <button type="button" className={styles.undo} disabled={!canUndo} onClick={onUndo}>
      <ArrowUUpLeftIcon size={20} aria-hidden />
      Undo
    </button>
  );
}
